function retrieveSIMNetworkProfile (e, modal) {
  modal.setState({isLoading: true});

  $.ajax({
    url: e.relatedTarget.dataset.networkProfileUrl,
    method: 'POST',
    success: ({sim_profile: simProfile}) => {
      modal.setState({
        body: '<pre id="network-profile" class="bg-light"></pre>',
        isDangerous: true,
      });

      // Pretty prints the object with an indentation of 2
      let prettyPrinted = JSON.stringify(simProfile, null, 2);

      modal.setState({isLoading: false}, () => {
        document.getElementById('network-profile').innerText = prettyPrinted;
      });
    },
    error: () => {
      modal.setState({
        isDangerous: false,
        isLoading: false,
        body: 'There was an error whilst trying to retrieve the SIM network profile.',
      });
    },
  });
}

const networkProfileModalConfig = {
  id: 'network-profile-modal',
  title: 'SIM Network Profile',
  body: '',
  isDangerous: true,
  isInfoModal: true,
  confirmButtonText: 'OK',
  loadingText: 'Retrieving SIM Network Profile',
  onConfirm: () => {},
  onOpen: retrieveSIMNetworkProfile,
};

export default networkProfileModalConfig;
